<div mti-font-contenido-consumos>
   <!-- Menu -->
   <app-left-slider-consumos></app-left-slider-consumos>

    <!-- #Menu -->
  <!-- Main Container -->
  <div class="container-fluid main-container-app">
   <router-outlet></router-outlet>
 </div>
</div>